
import { nodeHelpers } from '@/components/mixins/nodeHelpers';
import { showMessage } from '@/components/mixins/showMessage';

import BackgroundView from '@/components/BackgroundView.vue';
import AliareInput from '@/components/AliareInput.vue';
import InfoBox from '@/components/InfoBox.vue';
import AliareSelect from '@/components/AliareSelect.vue';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import Modal from '@/components/ModalAliare.vue';
import AlertNotificationModal from '@/components/AlertNotificationModal.vue';
import SearchDataCenterInput from '@/components/SearchDataCenterInput.vue';
import NotificationPage from '@/components/NotificationPage2.vue';
import { previousRoute } from '../router/index.ts';

import * as XLSX from 'xlsx';

import WebStorage from '@/common/WebStorage';
import { removeItemFromArrayByValue } from '@/components/helpers';
import { equivalencePermission } from '@/components/mixins/permissions/equivalences';

import { ref } from 'vue';
import axios from 'axios';
import { mapActions } from 'vuex';
import mixins from 'vue-typed-mixins';
import { restApi } from '@/components/mixins/restApi';

import { setupHeaderAliareTenant } from '@/config/axiosConfig';
import TokenService from '@/services/token.service';

enum StatusRelacionamento {
	RequerConfirmacao = 0,
	Conflito = 1,
	Relacionado = 2,
	NaoRelacionado = 3,
	Confirmado = 4,
	RelacionadoManualmente = 5
}

// Constantes string para os status (para uso no código)
const STATUS_RELACIONAMENTO = {
	REQUER_CONFIRMACAO: 'RequerConfirmacao',
	CONFLITO: 'Conflito',
	RELACIONADO: 'Relacionado',
	NAO_RELACIONADO: 'NaoRelacionado',
	CONFIRMADO: 'Confirmado',
	RELACIONADO_MANUALMENTE: 'RelacionadoManualmente'
};

export default mixins(
	restApi,
	nodeHelpers,
	showMessage,
	equivalencePermission,
).extend({
	components: {
		BackgroundView,
		AliareInput,
		AliareSelect,
		ModalButtonSuccess,
		ModalButtonCancel,
		SearchDataCenterInput,
		Modal,
		InfoBox,
		AlertNotificationModal,
		NotificationPage,
	},
	name: 'CreateEquivalence',
	data() {
		return {
			STATUS_RELACIONAMENTO, // Constantes para usar no template
			formParameters: {
				limitCharacter: false,
				percentageSimilar: ref(80),
				firstCharacter: ref(0),
				lastCharacter: ref(0),
				characterLimitTarget: 'both', // 'origin', 'equivalent', 'both'
			},
			filtroRelacionamento: 'todos',
			autoRelacionamentoRealizado: false,
			isLoadingAutoRelate: false,
			reloadComponent: true,
			isLoadingTable: true,
			isLoadingImport: false,
			equivalenceName: '',
			equivalenceData: '',
			selectedResourceOriginal: {},
			selectedResourceEquivalence: {},
			forms: ref([
				{ valorOrigem: '', valorEquivalente: '', descricao: '', isValid: null, showOrigem: false, showEquivalente: false, selected: false},
			]),
			canRegisterEquivalence: false,
			messageNameError: '',
			messageNameSuccess: '',
			optionsOriginalValue: [],
			extraLineAdded: 0,
			selectedRegisterLength: 0,
			optionsEquivalenceValue: [],
			dataCenterOriginal: {},
			dataCenterEquivalence: {},
			validateInputs: false,
			showAlert: {
				mode: '',
				show: false,
			},
			importedOriginalData: {
				name: '',
				valores: [],
			},
			importedEquivalenceData: {
				name: '',
				valores: [],
			},
			importedFile: false,
			showNotification: false,
			equivalenceActiveData: {},
			oldName: '',
			intervalStart: 0,
			intervalEnd: 50,
			currentStep: 'dataEquivalences',
			confirmResult: '',
			forceRedirect: false,
			isLoadingSave: false,
			isLoadingUpdate: false,
			stopPolling: false,
		};
	},
	computed: {
		allRegistersSelected() {
			return this.selectedRegisterLength == this.forms.length;
		},
		partialRegistersSelected() {
			return this.forms.length != this.selectedRegisterLength && this.selectedRegisterLength > 0;
		},
		buttonLoadResourceText() {
			if (this.isEdit && !this.isCompleteEquivalence) {
				return 'Carregar dados para  editar ou adicionar novos registros'
			} else if (this.isCompleteEquivalence) {
				return 'Carregar Dados'
			} else {
				return 'Carregar Registros'
			}
		},
		textEquivalence() {
			return this.isEdit ? 'Valores Equivalentes definidos' : 'Escolha os Valores Equivalentes';
		},
		textOrigin() {
			return this.isEdit ? 'Valores Origens Definidos' : 'Escolha os Valores Origens';
		},
		nameEquivalenceText() {
			return this.isEdit ? this.$locale.baseText('equivalences.editEquivalence.nameEquivalence') : this.$locale.baseText('equivalences.createEquivalence.giveName');
		},
		discardModalText() {
			if (this.showAlert.mode == 'closeScreen') {
				return this.isEdit ? this.$locale.baseText('Cancelar Edição') : this.$locale.baseText('Cancelar Cadastro');
			} else if (this.showAlert.mode == 'deleteRegisters') {
				return this.selectedRegisterLength > 1 ? 'Confirmar Exclusão em Massa' : 'Confirmar Exclusão do Registro';
			} else if (this.showAlert.mode == 'validateRegisters') {
				return 'Cancelar Validação';
			} else if (this.showAlert.mode == 'autoRelate') {
				return `Processar e sair`;
			} else if (this.showAlert.mode == 'leavePage') {
				return 'Sair sem salvar';
			}
		},
		keepModalText() {
			if (this.showAlert.mode == 'closeScreen') {
				return this.isEdit ? this.$locale.baseText('Manter Edição') : this.$locale.baseText('Manter Cadastro');
			} else if (this.showAlert.mode == 'deleteRegisters') {
				return this.selectedRegisterLength > 1 ? 'Manter Registros' : 'Manter Registro';
			} else if (this.showAlert.mode == 'validateRegisters') {
				return 'Validar';
			} else if (this.showAlert.mode == 'autoRelate') {
				return `Aguardar processamento`;
			} else if (this.showAlert.mode == 'leavePage') {
				return 'Salvar e sair';
			}
		},
		textStep() {
			if (this.isEdit && !this.isCompleteEquivalence) {
				return this.$locale.baseText('equivalences.editEquivalence.step1')
			} else if (this.isCompleteEquivalence) {
				return 'Finalização Equivalência'
			} else {
				return this.$locale.baseText('equivalences.createEquivalence.step1')
			}
		},
		equivalenceEditId() {
			if (this.isEdit) {
				return this.$route.params.id;
			} else {
				return '';
			}
		},
		pageTitle() {
			if (this.isEdit && !this.isCompleteEquivalence) {
				return this.$locale.baseText('equivalences.editEquivalence.title')
			} else if (this.isCompleteEquivalence) {
				return 'Finalizar Equivalência'
			} else {
				return this.$locale.baseText('equivalences.createEquivalence.title')
			}
		},
		addRegisterTitle() {
			return this.$locale.baseText('equivalences.createEquivalence.addRegister');
		},
		alertNotificationTitle() {
			if (this.showAlert.mode == 'closeScreen') {
				if (this.isEdit && !this.isCompleteEquivalence) {
					return 'Cancelamento de Edição'
				} else if (this.isCompleteEquivalence) {
					return 'Cancelar Finalização'
				} else {
					return 'Cancelamento do Cadastro'
				}
			} else if (this.showAlert.mode == 'deleteRegisters') {
				return this.selectedRegisterLength > 1 ? 'Exclusão em Massa' : 'Exclusão do Registro';
			} else if (this.showAlert.mode == 'validateRegisters') {
				return `Validar Relação`;
			} else if (this.showAlert.mode == 'autoRelate') {
				return `Relação de Registros`;
			} else if (this.showAlert.mode == 'leavePage') {
				return 'Sair da página';
			}
		},
		alertNotificationDescription() {
			if (this.showAlert.mode == 'closeScreen') {
				return 'Todas as parametrizações que estão sendo feitas serão <b>excluídas</b> e você <b>não poderá recuperá-las</b>. O que você deseja fazer?';
			} else if (this.showAlert.mode == 'deleteRegisters') {
				return this.selectedRegisterLength > 1 ? 'Excluir vários registros em massa apagará o Valor e Original, Valor Equivalente e Descrição de todos selecionados. O que deseja fazer?' : `Excluir o registro de código ${this.showAlert.selectedItem.valorOrigem.codigo} apagará o Valor e Original, Valor Equivalente e Descrição. O que deseja fazer?`;
			} else if (this.showAlert.mode == 'validateRegisters') {
				return `${this.selectedRegisterLength} registro${ this.selectedRegisterLength > 1 ? 's' : ''} relacionado${ this.selectedRegisterLength > 1 ? 's' : ''} manualmente`;
			} else if (this.showAlert.mode == 'autoRelate') {
				return `Este processo pode levar alguns minutos. Você pode aguardar o processamento aqui ou continuar navegando enquanto trabalhamos nisso. O que você deseja fazer?`;
			} else if (this.showAlert.mode == 'leavePage') {
				return 'Existem registros pendentes de confirmação. Deseja <b>salvar</b> as alterações antes de sair?';
			}
		},
		canCreateEquivalence() {
			const basicValidation = this.validateInputs && this.canRegisterEquivalence;
			
			if ((this.autoRelacionamentoRealizado && this.mode === 'Dados') || this.isCompleteEquivalence) {
				const todosConfirmados = this.forms.every(item => item.statusRelacionamento === STATUS_RELACIONAMENTO.CONFIRMADO || item.statusRelacionamento === STATUS_RELACIONAMENTO.RELACIONADO);
				return basicValidation && todosConfirmados;
			}
			
			return basicValidation;
		},
		isEdit() {
			return this.$route.name === 'editEquivalence' || this.$route.name === 'completeEquivalence' || this.$route.name === 'completeDraft';
		},
		isCompleteEquivalence() {
			return this.$route.name === 'completeEquivalence' || this.$route.name === 'completeDraft';
		},
		isCompleteDraft() {
			return this.$route.name === 'completeDraft';
		},
		mode() {
			return this.isEdit ? this.equivalenceData.tipoCadastro == 'Fonte de Dados' ? 'Dados' : 'Manual' : this.$route.params.mode;
		},
		workspace() {
			return this.$store.getters.workspace;
		},
		filteredForms() {
			if (this.filtroRelacionamento === 'todos' || this.mode !== 'Dados') {
				return this.forms;
			}
			if (this.filtroRelacionamento === STATUS_RELACIONAMENTO.CONFIRMADO) {
				return this.forms.filter(form => 
					form.statusRelacionamento === STATUS_RELACIONAMENTO.CONFIRMADO || 
					form.statusRelacionamento === STATUS_RELACIONAMENTO.RELACIONADO
				);
			}
			if (this.filtroRelacionamento === STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO) {
				return this.forms.filter(form => 
					form.statusRelacionamento === STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO || 
					form.statusRelacionamento === STATUS_RELACIONAMENTO.CONFLITO
				);
			}
			return this.forms.filter(form => form.statusRelacionamento === this.filtroRelacionamento);
		},
		hasVisibleItems() {
			return this.forms.some(item => this.shouldShowItem(item));
		},
	},
	methods: {
		clearSelectedItems() {
			this.forms.forEach((register) => {
				register.selected = false;
			});
			this.selectedRegisterLength = 0;
		},

		removeImportedFile(event, type) {
			event.stopPropagation();
			event.preventDefault();
			if (type === 'original') {
				this.importedOriginalData = {name: '', valores: []};
				const fileInput = document.getElementById('file-upload-original');
				if (fileInput) {
					fileInput.value = '';
				}
			} else if (type === 'equivalente') {
				this.importedEquivalenceData = {name: '', valores: []};
				const fileInput = document.getElementById('file-upload-equivalence');
				if (fileInput) {
					fileInput.value = '';
				}
			}
		},

		getStatusRelacionamentoEnum(status: string): number {
			const statusMap = {
				[STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO]: StatusRelacionamento.RequerConfirmacao,
				[STATUS_RELACIONAMENTO.CONFLITO]: StatusRelacionamento.Conflito,
				[STATUS_RELACIONAMENTO.RELACIONADO]: StatusRelacionamento.Relacionado,
				[STATUS_RELACIONAMENTO.NAO_RELACIONADO]: StatusRelacionamento.NaoRelacionado,
				[STATUS_RELACIONAMENTO.CONFIRMADO]: StatusRelacionamento.Confirmado,
				[STATUS_RELACIONAMENTO.RELACIONADO_MANUALMENTE]: StatusRelacionamento.RelacionadoManualmente
			};
			return statusMap[status] ?? StatusRelacionamento.RequerConfirmacao;
		},

		openConfirmAutoRelateModal() {
			this.showAlert = {
				show: true,
				mode: 'autoRelate',
			};
		},
		shouldShowItem(item) {
			if (this.filtroRelacionamento === 'todos' || this.mode !== 'Dados') {
				return true;
			}
			if (this.filtroRelacionamento === STATUS_RELACIONAMENTO.CONFIRMADO) {
				return item.statusRelacionamento === STATUS_RELACIONAMENTO.CONFIRMADO || 
					   item.statusRelacionamento === STATUS_RELACIONAMENTO.RELACIONADO;
			}
			if (this.filtroRelacionamento === STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO) {
				return item.statusRelacionamento === STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO || 
					   item.statusRelacionamento === STATUS_RELACIONAMENTO.CONFLITO;
			}
			return item.statusRelacionamento === this.filtroRelacionamento;
		},
		async pollEquivalenceAutomaticResults(workspaceId, equivalenceId) {
			// Polling de 5 em 5 segundos até obter resultado
			while (!this.stopPolling) {
				try {
					const { resultados } = await this.restApi().equivalenceAutomaticResults(workspaceId, equivalenceId);
					
					// Verificar se o resultado está pronto (não está vazio ou tem status de processamento)
					if (resultados && Array.isArray(resultados) && resultados.length > 0) {
						return resultados;
					}
					
					// Aguardar 5 segundos antes da próxima tentativa
					await new Promise(resolve => setTimeout(resolve, 5000));
					
				} catch (error) {
					// Se for erro de "ainda processando", continuar o polling
					if (error?.response?.status === 202 || error?.response?.status === 204) {
						await new Promise(resolve => setTimeout(resolve, 5000));
						continue;
					}
					
					// Se for outro tipo de erro, lançar exceção
					throw error;
				}
			}
		},
		async autoRelateOnBackground() {
			try {
				this.isLoadingAutoRelate = true;
				
				// Construir valoresOrigem a partir dos dados carregados na tela (this.forms)
				const valoresOrigemObj = {};
				const valoresEquivalentesObj = {};

				this.forms.forEach(form => {
					// Adicionar valores de origem
					if (form.valorOrigem?.codigo && form.valorOrigem?.descricao) {
						valoresOrigemObj[form.valorOrigem.codigo] = form.valorOrigem.descricao;
					}
				});

				// Pegar todos os valores equivalentes possíveis de optionsEquivalenceValue
				this.optionsEquivalenceValue.forEach(item => {
					valoresEquivalentesObj[item.codigo] = item.descricao;
				});

				const characterLimitConfig = {};
				if (this.formParameters.limitCharacter) {
					const target = this.formParameters.characterLimitTarget;
					if (target === 'origin' || target === 'both') {
						characterLimitConfig["numeroCaracteresIgnoradosOrigemPrefixo"] = this.formParameters.firstCharacter;
						characterLimitConfig["numeroCaracteresIgnoradosOrigemSufixo"] = this.formParameters.lastCharacter;
					}
					if (target === 'equivalent' || target === 'both') {
						characterLimitConfig["numeroCaracteresIgnoradosEquivalentePrefixo"] = this.formParameters.firstCharacter;
						characterLimitConfig["numeroCaracteresIgnoradosEquivalenteSufixo"] = this.formParameters.lastCharacter;
					}
				}

				const payload = {
					recursoIdOrigem: this.selectedResourceOriginal.id,
					recursoIdEquivalente: this.selectedResourceEquivalence.id,
					nomeEquivalencia: this.equivalenceName,
					similaridadeMinima: this.formParameters.percentageSimilar,
					...characterLimitConfig,
					valoresOrigem: valoresOrigemObj,
					valoresEquivalentes: valoresEquivalentesObj,
				}

				await this.restApi().automaticRelateBackground(this.workspace.id, payload);
				
				this.$router.push({ name: 'equivalences' });
			}  catch (error) {
				this.isLoadingAutoRelate = false;
				this.closeAlert();
				this.$store.commit('activeAlert', {
					message: 'Ocorreu um erro ao relacionar automaticamente as equivalências.',
					status: 'error',
				});
			}
		},
		async autoRelate() {
			try {
				this.isLoadingAutoRelate = true;
				let dataRelated;
				let equivalenceAutoRelateId

				// Construir valoresOrigem a partir dos dados carregados na tela (this.forms)
				const valoresOrigemObj = {};
				const valoresEquivalentesObj = {};

				this.forms.forEach(form => {
					// Adicionar valores de origem
					if (form.valorOrigem?.codigo && form.valorOrigem?.descricao) {
						valoresOrigemObj[form.valorOrigem.codigo] = form.valorOrigem.descricao;
					}
				});

				// Pegar todos os valores equivalentes possíveis de optionsEquivalenceValue
				this.optionsEquivalenceValue.forEach(item => {
					valoresEquivalentesObj[item.codigo] = item.descricao;
				});

				const characterLimitConfig = {};
				if (this.formParameters.limitCharacter) {
					const target = this.formParameters.characterLimitTarget;
					if (target === 'origin' || target === 'both') {
						characterLimitConfig["numeroCaracteresIgnoradosOrigemPrefixo"] = this.formParameters.firstCharacter;
						characterLimitConfig["numeroCaracteresIgnoradosOrigemSufixo"] = this.formParameters.lastCharacter;
					}
					if (target === 'equivalent' || target === 'both') {
						characterLimitConfig["numeroCaracteresIgnoradosEquivalentePrefixo"] = this.formParameters.firstCharacter;
						characterLimitConfig["numeroCaracteresIgnoradosEquivalenteSufixo"] = this.formParameters.lastCharacter;
					}
				}

				const payload = {
					recursoIdOrigem: this.selectedResourceOriginal.id,
					recursoIdEquivalente: this.selectedResourceEquivalence.id,
					nomeEquivalencia: this.equivalenceName,
					similaridadeMinima: this.formParameters.percentageSimilar,
					...characterLimitConfig,
					valoresOrigem: valoresOrigemObj,
					valoresEquivalentes: valoresEquivalentesObj,
				}

				if (this.isEdit || this.autoRelacionamentoRealizado) {
					const equivalenceId = this.isEdit ? this.equivalenceEditId : this.equivalenceData.id;
					equivalenceAutoRelateId = await this.restApi().automaticRelateCurrentEquivalence(this.workspace.id, equivalenceId, {
						recursoIdOrigem: this.selectedResourceOriginal.id,
						recursoIdEquivalente: this.selectedResourceEquivalence.id,
						...payload
					});
				} else {
					equivalenceAutoRelateId = await this.restApi().automaticRelateBackground(this.workspace.id, {
						recursoIdOrigem: this.selectedResourceOriginal.id,
						recursoIdEquivalente: this.selectedResourceEquivalence.id,
						...payload
					});
					this.equivalenceData = {
						id: equivalenceAutoRelateId
					}
				}

				

				// Fazer polling para obter resultados
				dataRelated = await this.pollEquivalenceAutomaticResults(
					this.workspace.id, 
					equivalenceAutoRelateId,
				);

				// Processar os dados retornados
				dataRelated.forEach((item) => {
					// Encontrar o form correspondente pelo valorOrigem
					const formIndex = this.forms.findIndex(
						form => form.valorOrigem?.codigo === item.valorOrigem
					);

					if (formIndex !== -1) {
						// Armazenar todas as correspondências no form
						this.forms[formIndex].correspondencias = item.correspondencias;

						// Encontrar a correspondência com maior similaridade que atende ao mínimo
						const melhorCorrespondencia = item.correspondencias
							.filter(corresp => corresp.similaridade >= this.formParameters.percentageSimilar)
							.sort((a, b) => b.similaridade - a.similaridade)[0];

						// Determinar status baseado na similaridade
						if (melhorCorrespondencia) {
							this.forms[formIndex].valorEquivalente = {
								codigo: melhorCorrespondencia.valorEquivalente,
								descricao: melhorCorrespondencia.descricaoEquivalente
							};
							this.forms[formIndex].valorAuto = melhorCorrespondencia;
							
							// Status: confirmado (100%) ou pendente (< 100%)
							if (melhorCorrespondencia.similaridade === 100) {
								this.forms[formIndex].statusRelacionamento = STATUS_RELACIONAMENTO.CONFIRMADO;
								this.forms[formIndex].prioridade = 3;
							} else {
								this.forms[formIndex].statusRelacionamento = STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO;
								this.forms[formIndex].prioridade = 2;
							}
						} else {
							// Não atingiu o mínimo - status não relacionado
							this.forms[formIndex].statusRelacionamento = STATUS_RELACIONAMENTO.NAO_RELACIONADO;
							this.forms[formIndex].prioridade = 1;
							// Limpar valorEquivalente se existir
							this.forms[formIndex].valorEquivalente = {
								codigo: '',
								descricao: ''
							};
						}
					}
				});

				// Ordenar a lista por prioridade (não relacionados primeiro, depois pendentes, depois confirmados)
				this.forms.sort((a, b) => {
					return (a.prioridade || 0) - (b.prioridade || 0);
				});

				this.autoRelacionamentoRealizado = true;

				// Revalidar os inputs após atualização
				this.validInputs();
				
				this.isLoadingAutoRelate = false;

		} catch (error) {
			this.isLoadingAutoRelate = false;
			this.$store.commit('activeAlert', {
				message: 'Ocorreu um erro ao relacionar automaticamente as equivalências.',
				status: 'error',
			});
		}
	},

	onValorEquivalenteChange(item, index) {
		// Fechar o dropdown
		item.showEquivalente = false;
		
		// Validar o item
		this.isValid(index);
		
		// Se o auto relacionamento foi realizado e o valor foi alterado manualmente
		if ((this.autoRelacionamentoRealizado || this.isCompleteEquivalence) && item.valorEquivalente && item.valorEquivalente.codigo) {
			// Mudar status para pendente para que o botão de confirmação fique disponível
			if (item.statusRelacionamento !== STATUS_RELACIONAMENTO.CONFIRMADO) {
				item.statusRelacionamento = STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO;
				item.prioridade = 2;
				
				// Reordenar a lista
				this.forms.sort((a, b) => {
					return (a.prioridade || 0) - (b.prioridade || 0);
				});
			}
		}
	},

	confirmarRelacionamentoManual(index) {
		const item = this.forms[index];
		
		// Verificar se o item tem status pendente (similaridade < 100% mas >= mínimo)
		if (item.statusRelacionamento === STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO || item.statusRelacionamento === STATUS_RELACIONAMENTO.CONFLITO) {
			// Mudar status para confirmado
			item.statusRelacionamento = STATUS_RELACIONAMENTO.CONFIRMADO;
			item.prioridade = 3;
			
			// Adicionar flag de relacionamento manual
			item.relacionadoManualmente = true;
			
			// Adicionar mensagem de relacionado manualmente
			item.mensagemRelacionamento = 'Confirmado manualmente';
			
			// Reordenar a lista (confirmados vão para o final)
			this.forms.sort((a, b) => {
				return (a.prioridade || 0) - (b.prioridade || 0);
			});
			
			// Revalidar inputs
			this.validInputs();
		}
	},

	confirmarRelacionamentoEmMassa() {
		let itensConfirmados = 0;
		
		// Iterar pelos itens selecionados
		this.forms.forEach((item) => {
			// Verificar se o item está selecionado
			if (item.selected) {
				// Verificar se não está confirmado
				if (item.statusRelacionamento !== STATUS_RELACIONAMENTO.CONFIRMADO) {
					// Verificar se possui valor equivalente válido
					if (item.valorEquivalente && 
						item.valorEquivalente.codigo && 
						item.valorEquivalente.codigo !== '') {
						
						// Verificar se tem status pendente (similaridade < 100% mas >= mínimo)
						if (item.statusRelacionamento === STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO || item.statusRelacionamento === STATUS_RELACIONAMENTO.CONFLITO) {
							// Mudar status para confirmado
							item.statusRelacionamento = STATUS_RELACIONAMENTO.CONFIRMADO;
							item.prioridade = 3;
							
							// Adicionar flag de relacionamento manual
							item.relacionadoManualmente = true;
							
							// Adicionar mensagem de relacionado manualmente
							item.mensagemRelacionamento = 'Confirmado manualmente';
							
							itensConfirmados++;
						}
					}
				}
			}
		});
		
		if (itensConfirmados > 0) {
			// Reordenar a lista (confirmados vão para o final)
			this.forms.sort((a, b) => {
				return (a.prioridade || 0) - (b.prioridade || 0);
			});
			
			// Revalidar inputs
			this.validInputs();
			
			// Exibir mensagem de sucesso
			this.$store.commit('activeAlert', {
				message: `${itensConfirmados} registro${itensConfirmados > 1 ? 's' : ''} confirmado${itensConfirmados > 1 ? 's' : ''} com sucesso!`,
				status: 'success',
			});
		} else {
			// Exibir mensagem de aviso
			this.$store.commit('activeAlert', {
				message: 'Nenhum item válido foi encontrado para confirmação. Verifique se os itens selecionados possuem status "pendente" e valor equivalente.',
				status: 'warning',
			});
		}

		this.clearSelectedItems();
	},

		keepAction() {
			if (this.showAlert.mode == 'validateRegisters') {
				this.confirmarRelacionamentoEmMassa();
				this.closeAlert()
			} else if (this.showAlert.mode == 'autoRelate') {
				this.autoRelate();
				this.closeAlert()
			} else if (this.showAlert.mode == 'leavePage') {
				this.confirmResult = 'save';
				this.closeAlert()
			} else {
				this.closeAlert()
			}
		},

		cancelAction() {
			if (this.showAlert.mode == 'validateRegisters') {
				this.closeAlert()
			} else if (this.showAlert.mode == 'autoRelate') {
				this.autoRelateOnBackground()
			} else if (this.showAlert.mode == 'leavePage') {
				this.confirmResult = 'leave';
				this.closeAlert()
			} else {
				this.showAlert.mode == 'closeScreen' ? this.redirectEquivalences() : this.removeRegisters()
			}
		},

		closeAlert() {
			this.showAlert = {
				show: false,
				isMultiple: false,
				selectedItem: '',
			};
		},
		openModalAlertValidateRegisters() {
			let isMultiple = this.selectedRegisterLength > 1 ? true : false;
			let selectedItem = !isMultiple ? this.forms.find(item => item.selected) : '';
			this.showAlert = {
				show: true,
				mode: 'validateRegisters',
				multiple: isMultiple,
				selectedItem,
			};
		},
		openModalAlertModeDeleteRegister() {
			let isMultiple = this.selectedRegisterLength > 1 ? true : false;
			let selectedItem = !isMultiple ? this.forms.find(item => item.selected) : '';
			this.showAlert = {
				show: true,
				mode: 'deleteRegisters',
				multiple: isMultiple,
				selectedItem,
			};
		},
		removeRegisters() {
			const selectedItems = this.forms.filter(item => item.selected);
			
			selectedItems.forEach(item => {
					this.extraLineAdded -= 1;
					
					const originalValue = {
						codigo: item.valorOrigem.codigo, 
						descricao: item.valorOrigem.descricao
					};
					
					this.optionsOriginalValue.push(originalValue);
			});
			

			this.clearSelectedItems()
			this.closeAlert();
		},
		toggleAllRegisters() {
			if (this.allRegistersSelected || this.partialRegistersSelected) {
				// Desmarcar apenas os registros visíveis (filtrados)
				this.filteredForms.forEach((register) => {
					register.selected = false;
				});
				this.selectedRegisterLength = 0;
			} else {
				// Selecionar apenas os registros visíveis (filtrados)
				this.filteredForms.forEach((register) => {
					register.selected = true;
				});
				this.selectedRegisterLength = this.filteredForms.length;
			}
			this.reloadComponent = false;
			this.reloadComponent = true;
		},
		toggleSelectedRegister(register, index) {
			if (this.verifyRegisterSelected(index)) {
				this.selectedRegisterLength -= 1;
				this.forms[index].selected = false;
			} else {
				this.selectedRegisterLength += 1;
				this.forms[index].selected = true;
			}
			this.reloadComponent = false;
			this.reloadComponent = true;
		},
		verifyRegisterSelected(index) {
			return this.forms[index].selected;
		},
		removeOption(index) {
			this.extraLineAdded -= 1;
			const item = {codigo: this.forms[index].valorOrigem.codigo, descricao: this.forms[index].valorOrigem.descricao};
			this.optionsOriginalValue.splice(this.optionsOriginalValue.findIndex(items => items.codigo === item.codigo), 1);
		},
		hiddenAllInputs() {
			this.forms.forEach(item => {
				if (item.showEquivalente || item.showOrigem) {
					item.showEquivalente = false;
					item.showOrigem = false;
				}
			});
		},
		openSelectEquivalence(index, id) {

			if (!this.importedFile) return;

			this.forms[index].showEquivalente = true;

			if (id) {
				this.reloadComponent = false;
				this.reloadComponent = true;
			}

			this.$nextTick(() => {
				this.$refs.selectEquivalence[0].$el.click();
			});
		},
		openSelectOrigem(index) {
			this.forms[index].showOrigem = true;
			this.$nextTick(() => {
				this.$refs.selectOrigem[0].$el.click();
			});
		},
		goToCreateNewEquivalence() {
			window.location.reload();
		},
		openModalAlertPreventClose() {
			this.showAlert.show = true;
			this.showAlert.mode = 'closeScreen';
		},
		goToEquivalence(id) {
			const equivalenceId = this.$route.name == 'createEquivalence' ? id : id.id;
			this.forceRedirect = true;
			this.$router.push({
				name: 'equivalencesDetailing',
				params: { id: equivalenceId },
			});
		},
		goToEquivalenceList() {
			this.forceRedirect = true;
			this.$router.push({
				name: 'equivalences',
			});
		},

		onImportChange(event, tipoValor) {
			this.isLoadingImport = true;
			try {
				var file = event.target.files[0];

				if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
					throw 'Arquivo Inválido. Escolha um arquivo .XLSX!';
				}

				const maxSize = 5 * 1024 * 1024; // 5MB em bytes
				if (file.size > maxSize) {
					throw 'Arquivo muito grande! O tamanho máximo permitido é 5MB.';
				}

				var vm = this;
				var reader = new FileReader();
				
				reader.onload = (event) => {
					try {
						// @ts-ignore
						var data = new Uint8Array(event.target.result);
						var workbook = XLSX.read(data, { type: "array" });
						var firstSheet = workbook.SheetNames[0];
						var worksheet = workbook.Sheets[firstSheet];
						var json = XLSX.utils.sheet_to_json(worksheet);

						let tipo = tipoValor;

						// Extrair valores com base no tipo
						const valoresExtraidos = json.map(el => {
							const coluna = tipo === 'ValoresOriginais' ? 'ValoresOriginais' : 'ValoresEquivalentes';
							return {
								codigo: (el?.[coluna] ?? '').toString(),
								descricao: (el?.Descricao ?? '').toString()
							};
						}).filter(item => item.codigo !== ''); // Remover linhas vazias

						// Distribuir valores conforme o tipo
						if (tipo === 'ValoresOriginais') {
							this.importedOriginalData.name = file.name
							this.importedOriginalData.valores = []

							// Valores originais vão para forms
							valoresExtraidos.forEach(valor => {
								this.importedOriginalData.valores.push({
									codigo: valor.codigo,
									descricao: valor.descricao
								});
							});
						} else if (tipo === 'ValoresEquivalentes') {
							this.importedEquivalenceData.name = file.name
							this.importedEquivalenceData.valores = []

							valoresExtraidos.forEach(valor => {
								this.importedEquivalenceData.valores.push({
									codigo: valor.codigo,
									descricao: valor.descricao
								});
							});
						}

						event.target.value = '';
						this.isLoadingImport = false;
						
					} catch (error) {
						console.error('Erro ao processar arquivo:', error);
						vm.$store.commit('activeAlert', {
							message: 'Erro ao processar o arquivo XLSX',
							status: 'error',
						});
					}
				};
					
				reader.readAsArrayBuffer(file);

			} catch (e) {
				console.error(e);
				this.isLoadingImport = false;

				this.$store.commit('activeAlert', {
					message: e,
					status: 'error',
				});
			}
		},
		async onFileChange(event) {
			this.isLoadingImport = true;
			try {
				var file = event.target.files[0];

				if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") throw 'Arquivo Inválido. Escolha um arquivo .XSLX!';

				const maxSize = 5 * 1024 * 1024; // 5MB em bytes
				if (file.size > maxSize) {
					throw 'Arquivo muito grande! O tamanho máximo permitido é 5MB.';
				}

				var vm = this;
				var reader = new FileReader();
				reader.onload = (event) => {
					// @ts-ignore
					var data = new Uint8Array(event.target.result);
					var workbook = XLSX.read(data, { type: "array" });
					var firstSheet = workbook.SheetNames[0];
					var worksheet = workbook.Sheets[firstSheet];
					var json = XLSX.utils.sheet_to_json(worksheet);

					vm.forms = [];

					json.forEach(el => {
						// @ts-ignore
						vm.forms.push({valorOrigem: (el?.ValoresOriginais ?? '').toString(), valorEquivalente: (el?.ValoresEquivalentes ?? '').toString(), descricao: (el?.Descricoes ?? '').toString()});
					})

					vm.valid = new Array(vm.forms.length).fill(false);
					// Validar inputs
					vm.forms.forEach((_, index) => {
						vm.valid[index] = vm.isValid(index);
					});
				};
				reader.readAsArrayBuffer(file);

				// Important to clear value, if the same file is upload active @change event
				event.target.value = '';
				this.importedFile = true;

				setTimeout(() => {
					this.isLoadingImport = false;
				}, 2000);

			} catch (e) {
				console.error(e);
				this.isLoadingImport = false;

				this.$store.commit('activeAlert', {
					message: e,
					status: 'error',
				});
			}


		},

		async loadResource() {
			this.isLoadingImport = true;

			this.importedFile = true;
			const removeRepeatItem = true;

			if (!this.isEdit) {
				this.forms = [];
			}
			let workflow1;
			let workflow2;
			let resourceToAdd = [];
			this.optionsEquivalenceValue = [];

			if (this.isCompleteEquivalence) {
				workflow1 = this.importedOriginalData.valores;
				workflow2 = this.importedEquivalenceData.valores;
			} else {
				try {
					workflow1 = this.importedOriginalData.valores.length ? this.importedOriginalData.valores : await this.restApi().getResourcesDataCenter(this.workspace.id, this.dataCenterOriginal.id, this.selectedResourceOriginal.id);
					workflow2 = this.importedEquivalenceData.valores.length ? this.importedEquivalenceData.valores : await this.restApi().getResourcesDataCenter(this.workspace.id, this.dataCenterEquivalence.id, this.selectedResourceEquivalence.id);
				} catch(e) {
					this.$store.commit('activeAlert', {
						message: 'Ocorreu um erro ao carregar os dados. Por favor, tente novamente mais tarde.',
						status: 'error',
					});
					this.isLoadingImport = false;
					return;
				}
			}


			workflow1.forEach(el => {
				if (this.isEdit) {
					let valueExist = this.forms.find(register => register.valorOrigem == el.codigo);
					if(valueExist) {
						valueExist.valorOrigem = { codigo: el.codigo.toString(), descricao: el.descricao};
					} else {
						resourceToAdd.push({valorOrigem:{ codigo: el.codigo.toString(), descricao: el.descricao}, valorEquivalente:{ codigo: '', descricao: ''} ,descricao: el.descricao, showOrigem: false, showEquivalente:false, newResource: true})
					}
				} else {
					this.forms.push({valorOrigem:{ codigo: el.codigo.toString(), descricao: el.descricao}, valorEquivalente:{ codigo: '', descricao: ''} ,descricao: el.descricao, showOrigem: false, showEquivalente:false});
				}
			});

			if (this.isEdit && !this.isCompleteEquivalence) {
				const valoresEquivalentes = this.forms.map(item => ({
					codigo: item.valorEquivalente,
					descricao: item.descricaoEquivalente,
				}));

				workflow2.push(...valoresEquivalentes)
			}
			workflow2.forEach(el => {
				if (this.isEdit) {
					this.forms.find(resourceData => {
						if(resourceData.valorEquivalente == el.codigo) {
							resourceData.valorEquivalente = { codigo: el.codigo.toString(), descricao: el.descricao};
							resourceData.showEquivalente = false;
						}
					});
				}

				this.optionsEquivalenceValue.push({codigo: el.codigo.toString(), descricao: el.descricao});
			});

			this.valid = new Array(this.forms.length).fill(false);

			if (this.isEdit && !this.isCompleteEquivalence) {
				if (resourceToAdd?.length) {
					this.$store.commit('activeAlert', {
						message: `Foi encontrado "${resourceToAdd.length}" novo(s) Registro, você poderá exclui-lo ou adiciona-lo à Equivalência.`,
					});
				} else {
					this.$store.commit('activeAlert', {
						message: `Não existem novos registros a serem inseridos.`,
					});
				}
			} else if (this.isCompleteEquivalence && resourceToAdd?.length) {
				this.$store.commit('activeAlert', {
					message: `Foi encontrado "${resourceToAdd.length}" novo(s) Registro desde que você solicitou o auto relacionamento, talvez seja necessário auto-relacionar novamente ou relaciona-los manualmente. `,
				});
			}
			this.forms.unshift(...resourceToAdd);

			this.isLoadingImport = false;

			this.validInputs(removeRepeatItem);
			this.currentStep = 'registerEquivalences';
		},
		validInputs(removeRepeatItem) {
			if (this.mode == 'Dados') {
				this.forms.slice(this.intervalStart, this.intervalEnd).forEach((_, index) => {
					this.valid[index] = this.isValid(index, removeRepeatItem);
				});
				if (this.intervalEnd < this.forms.length) {
					this.intervalStart = this.intervalStart + 50;
					this.intervalEnd = this.intervalEnd + 50;
					this.validInputs();
				}
			} else {
				this.forms.forEach((_, index) => {
					this.isValid(index);
				});
			}
		},
		selectedDataCenterOriginal(dataCenter) {
			this.dataCenterOriginal = dataCenter.data;
			this.selectedResourceOriginal = '';
		},
		selectedDataCenterEquivalence(dataCenter) {
			this.dataCenterEquivalence = dataCenter.data;
			this.selectedResourceEquivalence = '';
		},
		clearSelectedResource(type: string) {
			if (type === 'original') {
				this.selectedResourceOriginal = {};
			} else if (type === 'equivalence') {
				this.selectedResourceEquivalence = {};
			}
		},
		onSelectDataOriginalResource(type: string) {
			this.selectedResourceOriginal = type;
		},
		onSelectDataEquivalenceResource(type: string) {
			this.selectedResourceEquivalence = type;
		},


		isValid(index, removeRepeatItem) {
			if (index < 0 || index >= this.forms.length) {
				if (this.forms.length == 0) {
					this.validateInputs = false;
				}
				return false;
			}; // retorna false se o índice estiver fora dos limites

			let valuesEmpty;
			let values;
			let thisInputIsValid;

			if (this.mode == 'Dados') {
				valuesEmpty = this.forms
				.filter(form => form.valorOrigem == '' || form.descricao == '' || form.valorEquivalente.codigo == '').map(form => form.valorOrigem);

				values = this.forms
				.filter(form => form.valorOrigem.codigo !== '').map(form => form.valorOrigem.codigo); // diferente de vazio para não considerar inputs vazios duplicatas

			} else {
				valuesEmpty = this.forms
				.filter(form => form.valorOrigem == '' || form.descricao == '' || form.valorEquivalente == '').map(form => form.valorOrigem);

				values = this.forms
				.filter(form => form.valorOrigem !== '').map(form => form.valorOrigem); // diferente de vazio para não considerar inputs vazios duplicatas

			}

			let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index);


			let valuesDuplicates = findDuplicates(values);
			let hasDuplicates = valuesDuplicates.length > 0 ? true : false;
			let hasEmptyValue = valuesEmpty.length > 0 ? true : false;
			thisInputIsValid = !(valuesDuplicates.includes(this.forms[index].valorOrigem?.codigo || this.forms[index].valorOrigem));

			if (!hasDuplicates && !hasEmptyValue) {
				
				this.forms.forEach(form => {
					form.isValid = true;
				});
			} else {
				this.forms[index].isValid = thisInputIsValid;

				if (!thisInputIsValid && removeRepeatItem) {
					this.optionsOriginalValue.push({codigo: this.forms[index].valorOrigem.codigo.toString(), descricao: this.forms[index].valorOrigem.descricao});
					removeItemFromArrayByValue(this.forms, this.forms[index]);
				}
			}

			this.validateInputs = !hasDuplicates && !hasEmptyValue;
			return !hasDuplicates;
		},

		verifyNameEquivalence:
		_.debounce(async function (e)  {
			this.messageNameSuccess = '';
			this.messageNameError = '';
			this.canRegisterEquivalence = false;

			if(this.equivalenceName != '' && this.equivalenceName !== this.oldName) {

				const savedEquivalence = await this.restApi().checkAvailableNameEquivalences(this.workspace.id, {
					nome: this.equivalenceName
				});


				if (savedEquivalence) {
					this.messageNameError = this.$locale.baseText('equivalences.validationTitleInvalid');
					this.messageNameSuccess = '';
					this.canRegisterEquivalence = false;

				} else if (!savedEquivalence) {
					this.messageNameSuccess = this.$locale.baseText('equivalences.validationTitleValid');
					this.messageNameError = '';
					this.canRegisterEquivalence = true;
				}
			} else if (this.isEdit && this.equivalenceName === this.oldName) {
				this.canRegisterEquivalence = true;

			} else {
				this.messageNameSuccess = '';
				this.messageNameError = '';
				this.canRegisterEquivalence = false;
			}
		},500),

		async updateDraftEquivalence() {
			try {
				this.isLoadingUpdate = true;
				const equivalenceId = this.equivalenceData.id || this.$route.params.id;
				let valuesResource = this.forms.map((form) => {
					return {
						descricaoOrigem: form.valorOrigem.descricao,
						descricaoEquivalente: form.valorEquivalente.descricao,
						valorOrigem: form.valorOrigem.codigo,
						valorEquivalente: form.valorEquivalente.codigo, 
						descricao: form.descricao,
						statusRelacionamento: this.getStatusRelacionamentoEnum(form.statusRelacionamento),
						equivalenciaId: this.equivalenceData.id || this.$route.params.id,
					};
				});	
					

				await this.restApi().putEquivalence(this.workspace.id, equivalenceId, {
					nome: this.equivalenceName,
					valores: valuesResource,
				});
				

				if (this.isCompleteDraft || (this.isEdit && this.autoRelacionamentoRealizado)) {
					this.$store.commit('activeAlert', {
						message: `Rascunho atualizado com sucesso!`,
						status: 'success',
					});
				} else {
					this.$store.commit('activeAlert', {
						message: `Equivalência atualizada com sucesso!`,
						status: 'success',
					});
				}
					
				this.redirectEquivalences()
			} catch (error) {
				console.error(error);
				this.$store.commit('activeAlert', {
					message: 'Erro ao salvar a equivalência.',
					status: 'error',
				});
			} finally {
				this.isLoadingUpdate = false;
			}
		},
		async saveEquivalence() {
			// this.isLoadingTable = true;

			try {
				this.isLoadingSave = true;
				let savedEquivalence = {};
				let nameEquivalence = JSON.parse(JSON.stringify(this.equivalenceName));
				let valuesToPost = JSON.parse(JSON.stringify(this.forms));

				if (this.mode != 'Dados') {
					if (this.isEdit) {
						let valuesToPut = valuesToPost.filter((val) => val.equivalenciaId);
						let newValues = valuesToPost.filter((val) => !val.equivalenciaId);
						let payload = {};


						savedEquivalence = await this.restApi().putEquivalence(this.workspace.id, this.equivalenceEditId, {
							nome: this.equivalenceName,
							valores: valuesToPut,
						});

						if (newValues.length) {
							for (const form of newValues) {
								payload = {
									valorOrigem: form.valorOrigem,
									valorEquivalente: form.valorEquivalente,
									descricao: form.descricao,
								};

								await this.restApi().createNewRegister(this.workspace.id, this.equivalenceEditId, payload);

							}

						}
					} else {
						savedEquivalence = await this.restApi().createNewEquivalence(this.workspace.id, {
							nome: this.equivalenceName,
							valores: valuesToPost,
							tipoCadastro: this.mode == 'Manual' ? 'Manual' : this.mode == 'Importar' ? 'Importado' : '',
						});
					}

					this.equivalenceActiveData = {nome: nameEquivalence, id: savedEquivalence};
				} else {
					if (this.isEdit && !this.isCompleteEquivalence && !this.autoRelacionamentoRealizado) {
						let valuesToPutDataCenter = valuesToPost.filter((val) => val.equivalenciaId);
						let newValuesDataCenter = valuesToPost.filter((val) => !val?.equivalenciaId);

						let payload = {};

						let valuesResourcePut = valuesToPutDataCenter.map((form) => {
							return { valorOrigem: form.valorOrigem?.codigo || form.valorOrigem, valorEquivalente: form.valorEquivalente?.codigo || form.valorEquivalente,  descricao: form.descricao, equivalenciaId: form.equivalenciaId};
						});

						savedEquivalence = await this.restApi().putEquivalence(this.workspace.id, this.equivalenceEditId, {
							nome: this.equivalenceName,
							valores: valuesResourcePut,
						});


						if (newValuesDataCenter.length) {
							for (const form of newValuesDataCenter) {
								payload = {
									valorOrigem: form.valorOrigem.codigo == '' ? '' : form.valorOrigem.codigo || form.valorOrigem,
									valorEquivalente: form.valorEquivalente.codigo == '' ? '' : form.valorEquivalente.codigo || form.valorEquivalente,
									descricao: form.descricao,
								};

								await this.restApi().createNewRegister(this.workspace.id, this.equivalenceEditId, payload);

							}

						}
					} else if (this.isCompleteEquivalence || this.autoRelacionamentoRealizado) {
						const equivalenceId = this.equivalenceData.id || this.$route.params.id;
						let valuesResource = this.forms.map((form) => {
							return {
								valorOrigem: form.valorOrigem.codigo,
								valorEquivalente: form.valorEquivalente.codigo, 
								descricao: form.descricao,
								descricaoOrigem: form.valorOrigem.descricao,
								descricaoEquivalente: form.valorEquivalente.descricao,
								statusRelacionamento: this.getStatusRelacionamentoEnum(form.statusRelacionamento),
								equivalenciaId: this.equivalenceData.id || this.$route.params.id,
							};
						});


						savedEquivalence = await this.restApi().putEquivalence(this.workspace.id, equivalenceId, {
							nome: this.equivalenceName,
							valores: valuesResource,
						});
						await this.restApi().saveAutoRelatedEquivalence(this.workspace.id, equivalenceId);
					} else {
						let valuesResource = this.forms.map((form) => {
							return { valorOrigem: form.valorOrigem.codigo, valorEquivalente: form.valorEquivalente.codigo,  descricao: form.descricao};
						});
						savedEquivalence = await this.restApi().createNewEquivalence(this.workspace.id, {
							recursoIdOrigem: this.selectedResourceOriginal.id,
							recursoIdEquivalente: this.selectedResourceEquivalence.id,
							nome: this.equivalenceName,
							valores: valuesResource,
							tipoCadastro: 'Fonte_De_Dados',
						});
					}

					this.equivalenceActiveData = {nome: nameEquivalence, id: savedEquivalence};
				}

				this.showNotification = true;
			} catch (error) {
				console.error(error);

				this.$store.commit('activeAlert', {
					message: error?.notifications[0],
					status: 'error',
				});

				if (this.isEdit) {
					this.loadCurrentEquivalence();
				}

			}  finally {
				this.isLoadingSave = false;
			}
		},
		addFormRegister() {
			this.extraLineAdded += 1;
			if (this.mode != 'Dados') {
				this.forms.push({valorOrigem: '', valorEquivalente: '', descricao: '', isValid: null});
			} else {
				this.forms.push({valorOrigem: {codigo: '', descricao: ''}, valorEquivalente: {codigo: '', descricao: ''}, descricao: '', showOrigem: false, showEquivalente:false, isValid: null});
			}
			this.validInputs();
		},
		removeRow(index) {
			let splicedArray = JSON.parse(JSON.stringify(this.forms));
			if (splicedArray[index].valorOrigem?.codigo) {
				this.optionsOriginalValue.push({codigo: splicedArray[index].valorOrigem.codigo, descricao: splicedArray[index].valorOrigem.descricao});
			} else {
				this.extraLineAdded -= 1;
			}
			removeItemFromArrayByValue(splicedArray, splicedArray[index]);
			this.forms = splicedArray;
			this.validInputs();
		},

		redirectEquivalences() {
			this.forceRedirect = true;
			this.$router.push({	name: 'equivalences' });
		},
		async loadCurrentEquivalence() {
			this.isLoadingTable = true;
			const vm = this;

			try {
				
				const currentEquivalence = await this.restApi().getEquivalenceById(this.workspace.id, this.equivalenceEditId)
				const results = await this.restApi().equivalenceAutomaticResults(this.workspace.id, this.equivalenceEditId)

				this.equivalenceData = currentEquivalence;
				this.equivalenceName = currentEquivalence.nome;
				this.oldName = currentEquivalence.nome;
				this.forms = currentEquivalence.valores;

				if (this.isCompleteDraft) {
					const valorRascunho = await this.restApi().getEquivalenciaRascunho(this.workspace.id, this.equivalenceEditId)
					this.forms = valorRascunho.valores;
					currentEquivalence.valores = valorRascunho.valores;
				} else {
					this.forms = currentEquivalence.valores;
				}

				vm.valid = new Array(vm.forms.length).fill(false);

				// Validar inputs
				this.forms.forEach((_, index) => {
					this.isValid(index);
				});
				
				
				if (this.isEdit && this.mode == 'Dados' && currentEquivalence.recursoOrigem?.fonteDeDados && !this.isCompleteEquivalence) {
					// Carregar DataCenter Original completo
					try {
						const dataCenterOriginalData = await this.restApi().getDataCenterById(
							this.workspace.id,
							currentEquivalence.recursoOrigem.fonteDeDados.id
						);
						this.dataCenterOriginal = dataCenterOriginalData;
						
						// Encontrar e selecionar o recurso específico
						const recursoOriginal = dataCenterOriginalData.recursos?.find(
							r => r.id === currentEquivalence.recursoOrigem.id
						);
						if (recursoOriginal) {
							this.selectedResourceOriginal = recursoOriginal;
						}
					} catch (error) {
						console.error('Erro ao carregar DataCenter Original:', error);
					}

					// Carregar DataCenter Equivalente completo
					try {
						const dataCenterEquivalenteData = await this.restApi().getDataCenterById(
							this.workspace.id,
							currentEquivalence.recursoEquivalente.fonteDeDados.id
						);
						this.dataCenterEquivalence = dataCenterEquivalenteData;
						
						// Encontrar e selecionar o recurso específico
						const recursoEquivalente = dataCenterEquivalenteData.recursos?.find(
							r => r.id === currentEquivalence.recursoEquivalente.id
						);
						if (recursoEquivalente) {
							this.selectedResourceEquivalence = recursoEquivalente;
						}
					} catch (error) {
						console.error('Erro ao carregar DataCenter Equivalente:', error);
					}
				} else if (this.isCompleteEquivalence) {
					currentEquivalence.valores.map(item => {
						if (item.statusRelacionamento === STATUS_RELACIONAMENTO.CONFIRMADO || item.statusRelacionamento === STATUS_RELACIONAMENTO.RELACIONADO) {
							item.statusRelacionamento = STATUS_RELACIONAMENTO.CONFIRMADO;
							item.prioridade = 3;
						} else if (item.statusRelacionamento === STATUS_RELACIONAMENTO.REQUER_CONFIRMACAO || item.statusRelacionamento === STATUS_RELACIONAMENTO.CONFLITO) {
							item.prioridade = 2;
						}
					})
					const valoresOriginais = currentEquivalence.valores.map(item => ({
						codigo: item.valorOrigem,
						descricao: item.descricaoOrigem,
						statusRelacionamento: item.statusRelacionamento,
					}));

					// Processar valores equivalentes de resultados e itens orfãos
					const valoresEquivalentesMap = new Map();
					
					// Adicionar correspondências dos resultados
					if (results?.resultados) {
						results.resultados.forEach(resultado => {
							if (resultado.correspondencias && Array.isArray(resultado.correspondencias)) {
								resultado.correspondencias.forEach(correspondencia => {
									const key = correspondencia.valorEquivalente;
									if (!valoresEquivalentesMap.has(key)) {
										valoresEquivalentesMap.set(key, {
											codigo: correspondencia.valorEquivalente,
											descricao: correspondencia.descricaoEquivalente,
										});
									}
								});
							}
						});
					}
					
					// Adicionar itens orfãos
					if (results?.itensOrfaos) {
						results.itensOrfaos.forEach(orfao => {
							const key = orfao.valorEquivalente;
							if (!valoresEquivalentesMap.has(key)) {
								valoresEquivalentesMap.set(key, {
									codigo: orfao.valorEquivalente,
									descricao: orfao.descricaoEquivalente,
								});
							}
						});
					}
					
					// Converter Map para array
					const valoresEquivalentes = Array.from(valoresEquivalentesMap.values());

					this.importedOriginalData.valores = valoresOriginais;
					this.importedEquivalenceData.valores = valoresEquivalentes;

					this.forms.sort((a, b) => {
						return (a.prioridade || 0) - (b.prioridade || 0);
					});

					this.loadResource();
				}
				this.isLoadingTable = false;
				return currentEquivalence;

			} catch (error) {
				this.$store.commit('activeAlert', {
					message: 'Ocorreu um problema ao carregar a equivalência, tente novamente.',
					status: 'error',
				});

				console.error(error);

				this.forceRedirect = true;
				this.$router.push({
					name: 'equivalences',
				});
				return;
			}
		},
		async verifyMode() {
			this.isLoadingTable = true;
			if (this.isEdit) {
				this.validateInputs = true;
				this.canRegisterEquivalence = true;
			}
			this.isLoadingTable = false;
		},
		async verifyPermissionUserAndInitiate() {
			await this.validationAccessEquivalences().then(async () => {
				let currentEquivalence;

				if (this.isEdit) {
					currentEquivalence = await this.loadCurrentEquivalence();
				}

				if (this.isEdit ? this.canEditEquivalence(currentEquivalence) : this.registerEquivalencePermission) {
					this.verifyMode();
				} else {
					this.$store.commit('setData403', {show: true, prevPage: previousRoute});
				}
			});
		},
	},
	async beforeRouteLeave(to, from, next) {
		// Se é redirecionamento forçado por erro, permite sair sem modal
		if (this.forceRedirect) {
			next();
			return;
		}

		if (this.isCompleteEquivalence || this.autoRelacionamentoRealizado) {			
				this.showAlert = {
					show: true,
					mode: 'leavePage',
				};
				
				const result = await new Promise((resolve) => {
					const checkResult = setInterval(() => {
						if (!this.showAlert.show) {
							clearInterval(checkResult);
							resolve(this.confirmResult);
						}
					}, 100);
				});
				
				if (result === 'save') {
					// Salvar antes de sair
					const equivalenceId = this.equivalenceData.id || this.$route.params.id;
				
					let valuesResource = this.forms.map((form) => {
						return {
							descricaoOrigem: form.valorOrigem.descricao,
							descricaoEquivalente: form.valorEquivalente.descricao,
							valorOrigem: form.valorOrigem.codigo,
							valorEquivalente: form.valorEquivalente.codigo, 
							descricao: form.descricao,
							statusRelacionamento: this.getStatusRelacionamentoEnum(form.statusRelacionamento),
							equivalenciaId: this.equivalenceData.id || this.$route.params.id,
						};
					});
					await this.restApi().putEquivalence(this.workspace.id, equivalenceId, {
						nome: this.equivalenceName,
						valores: valuesResource,
					});
					next();
				} else if (result === 'leave') {
					// Sair sem salvar
					next();
				} else {
					// Cancelar e permanecer
					next(false);
				}
		} else {
			next();
		}
	},
	created() {
		this.verifyPermissionUserAndInitiate();
	},
	mounted() {

	},
	beforeDestroy() {
		this.stopPolling = true;
	},
});
